var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9874 16.7504C23.0211 20.3824 26.1735 21.591 26.2085 21.6065C26.1818 21.6917 25.7048 23.3289 24.5476 25.0199C23.5473 26.482 22.5091 27.9386 20.8737 27.9688C19.2667 27.9984 18.7499 27.0159 16.9127 27.0159C15.076 27.0159 14.5018 27.9386 12.9806 27.9984C11.402 28.0582 10.1999 26.4174 9.19127 24.9608C7.13027 21.9811 5.55524 16.5409 7.6701 12.8687C8.72072 11.0451 10.5983 9.8903 12.6362 9.86069C14.1863 9.83112 15.6495 10.9036 16.5972 10.9036C17.5442 10.9036 19.3223 9.61385 21.1915 9.80327C21.974 9.83584 24.1706 10.1194 25.581 12.1839C25.4674 12.2544 22.9601 13.714 22.9874 16.7504V16.7504ZM19.9672 7.83196C20.8053 6.81747 21.3694 5.4052 21.2155 4C20.0074 4.04855 18.5466 4.80502 17.6801 5.81896C16.9035 6.71684 16.2234 8.15397 16.4069 9.53135C17.7535 9.63553 19.129 8.8471 19.9672 7.83196",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple_icon.8d10310e9357b3cf9aa00a2ac753f913.svg";
export { ForwardRef as ReactComponent };